import {
    useState,
    useEffect
} from "react";


import Spinner from "../spinners/DataSpinner";

import axios from "axios";

import swal from "sweetalert";

import {
    Link,
    useNavigate
} from "react-router-dom";

const Cart = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [cart, setCart] = useState([]);


    let grandTotal = 0;

    useEffect(() => {

        let isMounted = true;

        axios.get(`api/cart`)
            .then(res => {
                if (isMounted) {
                    if (res.data.status === 200) {
                        setCart(res.data.cart);
                        setLoading(false);
                    } else if (res.data.status == 401) {
                        swal('Warning', res.data.message, 'error');
                        navigate("/");
                    }
                }
            });

        return () => {
            isMounted = false;
        }
    }, [navigate]);

    const handleDecrement = (e, id) => {
        e.preventDefault();
        setCart((cart) =>
            cart.map((item) =>
                id === item.id ? { ...item, product_qty: item.product_qty - (item.product_qty > 1 ? 1 : 0) } : item
            )
        );
        updateQuantity(id, 'dec', e.currentTarget);
    }

    const handleIncrement = (e, id) => {
        e.preventDefault();
        setCart((cart) =>
            cart.map((item) =>
                id === item.id ? { ...item, product_qty: item.product_qty + (item.product_qty < 10 ? 1 : 0) } : item
            )
        );
        updateQuantity(id, 'inc', e.currentTarget);
    }

    const updateQuantity = (id, type, e) => {
        e.innerHtml = '+';
        axios.get(`api/cart/update-qty/${id}/${type}`)
            .then(res => {
                if (res.data.status === 200) {
                    e.innerHtml = type == 'dec' ? '-' : '+';
                }
            });
    }

    const deleteItem = (e, id) => {
        e.preventDefault();
        const thisClicked = e.currentTarget;
        thisClicked.innerText = "Removing";

        axios.delete(`/api/cart/delete-item/${id}`).then(res => {
            if (res.data.status == 200) {
                swal("Success", res.data.message, 'success');
                thisClicked.closest("tr").remove();
            } else if (res.data.status == 404) {
                swal("Success", res.data.message, 'success');
                thisClicked.innerText = "Remove";
            }
        });
    }

    if (loading) {
        return <Spinner />
    } else {
        var cartHtml = '';
        if (cart.length) {
            cartHtml =
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 border rounded bg-white pt-4 pb-3 mt-4">
                    <div className="col-lg-12 table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th className="text-center">Image</th>
                                    <th className="text-center">Product</th>
                                    <th className="text-center">Price</th>
                                    <th className="text-center">Qty</th>
                                    <th className="text-center">Total</th>
                                    <th className="text-center">remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cart.map((item) => {
                                    grandTotal += item.product_qty * item.product.sale_price;
                                    return (
                                        <tr key={item.id}>
                                            <td>
                                                <img src={`${process.env.REACT_APP_API_URL}/public/uploads/products/${item.product.image}`} className="img-fluid d-block m-auto" width="40" height="40" alt={item.product.image} />
                                            </td>
                                            <td className="text-center align-middle">{item.product.name}</td>
                                            <td className="text-center align-middle">{item.product.sale_price}</td>
                                            <td className="text-center align-middle">
                                                <div>
                                                    <button className="btn btn-primary btn-sm" onClick={(e) => handleIncrement(e, item.id)}>+</button>
                                                    <span className="px-3">{item.product_qty}</span>
                                                    <button className="btn btn-primary btn-sm" onClick={(e) => handleDecrement(e, item.id)}>-</button>
                                                </div>
                                            </td>
                                            <td className="text-center align-middle">{item.product_qty * item.product.sale_price}$</td>
                                            <td>
                                                <button className="d-block m-auto btn btn-danger btn-sm" onClick={(e) => deleteItem(e, item.id)}>Remove</button>
                                            </td>
                                        </tr>
                                    )
                                })

                                }
                            </tbody>
                        </table>
                    </div>

                    <div className="col-lg-8"></div>
                    <div className="col-lg-4">
                        <div className="card card-body mt-3">
                            <h5> Sub Total:
                                <span className="float-end">{grandTotal}$</span>
                            </h5>
                            <h5> Grand Total:
                                <span className="float-end">{grandTotal}$</span>
                            </h5>
                            <hr />
                            <Link to="/checkout" className="btn btn-primary">Checkout</Link>
                        </div>
                    </div>
                </div>
        } else {
            cartHtml = <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3  rounded bg-white">
                <div className="col-lg-12">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th className="text-center">Image</th>
                                <th className="text-center">Product</th>
                                <th className="text-center">Price</th>
                                <th className="text-center">Qty</th>
                                <th className="text-center">Total</th>
                                <th className="text-center">remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="6" className="text-center"> The cart is empty</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        }
    }

    return (
        <div className="album py-5 bg-light">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">Collections</li>
                    </ol>
                </nav>
                {cartHtml}
            </div>
        </div>
    );
}

export default Cart;